module.exports = __webpack_public_path__ + "static/media/nft-dapper.71564c12.png";